import { deleteRequest, get, publicPost, put } from "../../helpers/apihelpers";

export const CreateBookingSlotService=async(data)=>{
    try {
        const result = await publicPost(`api/booking_slot/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateBookingSlotService=async(data,id)=>{
    try {
        const result = await put(`api/booking_slot/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetBookingSlotService=async()=>{
    try {
        const result = await get(`api/booking_slot/get`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteBookingSlotService=async(id)=>{
    try {
        const result = await deleteRequest(`api/booking_slot/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

